import store from "@/store"

async function handleLogInEvent() {}

async function handleLogOutEvent() {
  try {
    await store.dispatch("stagedRxOrders/clearStagedRxOrdersForAllCarePlans")
  } catch (e) {
    console.error("Error clearing staged Rx orders on logout:", e)
  }
}

export default {
  handleLogInEvent,
  handleLogOutEvent
}
